























import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CompanyHeader from "@/components/company/Header.vue";
import MemberHeader from "@/components/member/Header.vue";
import SaleHeader from "@/components/sale/Header.vue";
import { IUser } from "@/types/user";

@Component({
  components: {
    CompanyHeader,
    MemberHeader,
    SaleHeader,
  },
})
export default class extends Vue {
  @Getter("auth/isCompany")
  public isCompany!: boolean;
  @Getter("auth/isMember")
  public isMember!: boolean;
  @Getter("auth/isSale")
  public isSale!: boolean;
  @Getter("auth/me")
  public user!: IUser;

  @Getter("isLoading")
  public isLoading!: boolean;
  // @Watch("getRole")
  // public async changeAbilities() {
  //   console.log("watch");
  //   this.isCompany();
  //   this.isMember();
  //   this.isSale();
  // await Promise.all([this.isCompany(), this.isMember(), this.isSale()]);
  // }
}
